import * as amplitude from "@amplitude/analytics-browser";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Link } from "@redotech/redo-web/link";
import { DATE_FORMAT } from "@redotech/redo-web/time";
import { memo, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BillingBannerEvents } from "./billing-events";
import * as failedAlertCss from "./failed-alert.module.css";

export function BillingAlertCtaButton({
  to,
  currentPath,
  onClick,
  text,
}: {
  to: string;
  currentPath: string;
  onClick: () => void;
  text: string;
}) {
  const navigate = useNavigate();
  if (currentPath === to) {
    return null;
  }
  return (
    <RedoButton
      hierarchy="secondary"
      onClick={() => {
        onClick();
        navigate(to);
      }}
      size="sm"
      text={text}
    />
  );
}

export const BillingFailedAlert = memo(function FailedAlert() {
  const team = useContext(TeamContext);
  const [closed, setClosed] = useState(false);
  const location = useLocation();

  return team &&
    team.failed_payouts > 0 &&
    team.billingMethod !== "fake" &&
    team.billingMethod !== "offline" &&
    team.billingFailure !== "allow" &&
    !closed ? (
    <div className={failedAlertCss.header}>
      <div>
        We were unable to collect payment. Please update your billing info in
        the <Link to="settings/billing">billing settings.</Link>
        <br />
        The return portal will be disabled on{" "}
        {DATE_FORMAT.format(new Date(team.shutdown_date))}.
      </div>
      <BillingAlertCtaButton
        currentPath={location.pathname}
        onClick={() =>
          amplitude.track(
            BillingBannerEvents.FAILED_PAYMENT_VIEW_INVOICES_CLICKED,
          )
        }
        text="View invoices"
        to="/settings/invoices"
      />
      <RedoButton
        aria-label="Dismiss"
        IconLeading={XCloseIcon}
        onClick={() => {
          amplitude.track(BillingBannerEvents.FAILED_PAYMENT_DISMISSED);
          setClosed(true);
        }}
        size="sm"
      />
    </div>
  ) : null;
});
